import AppLayout from "@/components/AppLayout";
import { ClientSidebar } from "@/components/sidebars";
import { useAuth } from "@/lib/auth";
import BeneficiariosEditor from "@/components/BeneficiariosEditor";

export default function Beneficiarios() {
  const { user, setUser } = useAuth();
  const maxAllowed = user?.plan === "basico" ? 1 : 4;

  return (
    <AppLayout sidebar={ClientSidebar}>
      <header className="app-header">
        <h1>Beneficiarios en México</h1>
        <p className="text-muted">Estas son las personas a las que enviaremos servicio. Mantén sus datos actualizados.</p>
      </header>
      <div className="panel">
        <BeneficiariosEditor user={user} maxAllowed={maxAllowed} onSaved={(u) => setUser(u)} />
      </div>
    </AppLayout>
  );
}
